import { Image } from "antd";
import favIconUrl from "assets/Images/loadingImage.png";

const GeneralLoadingSpinner = () => {
  return (
    <div className="fixed top-0 left-0 w-full h-screen flex items-center justify-center z-50 pointer-events-none backdrop-blur-sm">
     
      <div className="relative flex items-center justify-center bg-[#FFEDCC] p-4 rounded-full shadow-lg">
       
        <div className="loader absolute w-[80px] h-[80px]"></div>

       
        <div className="relative w-[40px] h-[40px] flex items-center justify-center bg-[#FFEDCC] rounded-full z-10">
          <Image src={favIconUrl} alt="loading" width={30} height={30} />
        </div>
      </div>
    </div>
  );
};

export default GeneralLoadingSpinner;
